import { useTranslation } from 'react-i18next';
import { allocationService } from '../services/allocationService';
import type { UnallocatedFilters } from '../types/Checks';
import type { ScopedExportRequest } from '../types/Filters';
import { useSpreadsheetExport } from './useSpreadsheetExport';
import type { UnallocatedColumn } from './useUnallocatedColumns';

/** Filtros, ordenação e colunas valem nos dois escopos; `page` leva também a página e o tamanho dela. */
export function useExportUnallocated(
  { page, perPage, ...filters }: UnallocatedFilters,
  columns: readonly UnallocatedColumn[],
) {
  const { t } = useTranslation('alocacao');
  return useSpreadsheetExport<ScopedExportRequest>(
    ({ scope, ...options }) =>
      allocationService.exportUnallocated(
        scope === 'page' ? { ...filters, page, perPage } : filters,
        { ...options, columns },
      ),
    t('consultas.semAlocacao.nomeArquivo'),
  );
}
